import { Flex, IconArrowDown, Typography } from '@banhala/ui-kit';

type Props = {
  birthday: string | null;
  onPress: () => void;
};

export const BirthdaySelector = ({ birthday, onPress }: Props) => {
  const hasValue = birthday != null && birthday.length > 0;
  return (
    <Flex.Row
      padding={{ vertical: 14, horizontal: 16 }}
      borderWidth={1}
      borderColor={'border_secondary'}
      borderRadius={8}
      backgroundColor={'bg_primary'}
      alignItems={'center'}
      justifyContent={'space-between'}
      onPress={onPress}
    >
      <Typography
        type="body1"
        color={hasValue ? 'content_primary' : 'content_tertiary'}
      >
        {hasValue ? birthday : '생년월일 선택'}
      </Typography>

      <IconArrowDown size={16} />
    </Flex.Row>
  );
};
